import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Named } from '../base/named';

/**
 * Represents a tag which can group a set of concept entities such as pipelines, datasets and data flows.
 */
@Metamodel.model({
    referable: true
})
export class Tag extends Named {
    public static readonly MODEL: IModel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public value: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public constructor(value?: any) {
        super(value?.toString());
        if (value != null) {
            this.value = value;
        }
    }
}
